import { render, staticRenderFns } from "./InfoMetaList.vue?vue&type=template&id=2b2eaa6e&scoped=true"
import script from "./InfoMetaList.vue?vue&type=script&lang=js"
export * from "./InfoMetaList.vue?vue&type=script&lang=js"
import style0 from "./InfoMetaList.vue?vue&type=style&index=0&id=2b2eaa6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2eaa6e",
  null
  
)

export default component.exports